import dayjs from "dayjs";

import type { CarOrderDetailDriverInfo } from "@/api/car";

/** 与订单列表 resolveMainStatusStep(car) 一致 */
export const CAR_MAIN_PROGRESS_TITLES = [
  "待支付",
  "待确认",
  "待签约",
  "待派车",
  "已完成",
] as const;

export function resolveCarMainProgressStep(
  status: number,
  hasRefund: boolean,
  refund_status: number,
): number {
  if (hasRefund && refund_status !== 30) return -1;
  const s = Number.isFinite(status) ? Math.trunc(status) : 0;
  if (s <= 4 && s >= 0) return s;
  if ((s === 5 && s <= 0) || s === 6) return 0;
  if (s === 7) return 5;
}

export function formatPickupReturn(dateIso: string, timeStr: string): string {
  const d = dayjs(dateIso);
  const datePart = d.isValid() ? d.format("YYYY-MM-DD") : dateIso.slice(0, 10);
  const t = (timeStr || "").slice(0, 5);
  return t ? `${datePart} ${t}` : datePart;
}

export function photosFromBlock(inspect: {
  front: string | null;
  side: string | null;
  rear: string | null;
}): { label: string; url: string }[] {
  const rows = [
    { label: "车头", url: inspect.front },
    { label: "车身", url: inspect.side },
    { label: "车尾", url: inspect.rear },
  ];
  return rows
    .filter((r): r is { label: string; url: string } => !!r.url)
    .map((r) => ({ label: r.label, url: r.url }));
}

export function maskMiddle(s: string, keep = 3): string {
  if (!s || s.length <= keep * 2) return s || "—";
  return `${s.slice(0, keep)}***${s.slice(-keep)}`;
}

export function hasAssignedDriver(
  d: CarOrderDetailDriverInfo | null | undefined,
): d is CarOrderDetailDriverInfo {
  if (d == null) return false;
  return Boolean(
    (d.name && d.name.trim()) ||
    (d.phone && d.phone.trim()) ||
    (d.license_plate && d.license_plate.trim()),
  );
}
